import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "30px 40px 10px 40px",
  },
  header: {
    fontSize: "12",
    display: "flex",
    flexDirection: "row",
    // margin: "0px 50px 10px 50px",
  },
  words: {
    margin: "5px",
  },
  word1: {
    margin: "5px",
    width: "70%",
  },
  word2: {
    margin: "5px",
    width: "10%",
    textAlign: "right",
  },
  word3: {
    margin: "5px",
    width: "20%",
  },
  section: {
    borderBottom: "1pt dashed black",
    margin: "0px 20px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  section2: {
    fontSize: "14",
    // margin: "0px 52px",
    display: "flex",
    flexDirection: "row",
  },
  item1: {
    marginLeft: "25px",
    fontSize: "12",
    fontWeight: "200",
    width: "140px",
  },
  item2: {
    marginLeft: "25px",
    fontSize: "12",
    width: "30px",
    fontWeight: "200",
    textAlign: "right",
  },
  item3: {
    marginLeft: "5px",
    fontSize: "12",
    width: "90px",
    fontWeight: "200",
  },
});

export default function OrderSlip({ groupedProducts, products, invoice }) {
  function uniqueBillibleProducts() {
    const billibleProducts = [];
    const combinedIds = new Set();

    products?.forEach((product) => {
      if (
        !combinedIds.has(product.combinedId) ||
        !product.combinedId ||
        product.combinedId < 1
      ) {
        billibleProducts.push(product);
        combinedIds.add(product.combinedId);
      }
    });

    return billibleProducts;
  }

  return (
    <Document
      onLoadSuccess={async (successEvent) => {
        // tslint:disable-next-line:await-promise
        const data = await successEvent.getData();

        const newblob = new Blob([data], { type: "application/pdf" });

        window.open(URL.createObjectURL(newblob));
      }}
    >
      <Page size="LETTER" style={styles.page}>
        <View style={styles.header}>
          <View
            // fixed
            style={{
              fontSize: "16px",
              display: "flex",
              flexDirection: "column",
              margin: "10px",
              marginLeft: "0px",
              // marginLeft: "20px",
            }}
          >
            <Text>Korns Bakery</Text>
            <Text>5004 16 Ave.</Text>
            <Text>Brooklyn New York 11204</Text>
            <Text>(718) 851-0268</Text>
          </View>

          <View
            // fixed
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "10px",
              marginLeft: "auto",
              width: "190px",
            }}
          >
            <Text>Invoice Number: {invoice?.invoiceId}</Text>
            <Text>Invoice Date: {invoice?.invoiceDate}</Text>
            <Text>Order Number: {invoice?.orderId}</Text>
            <Text>Delivery Date: {invoice?.deliveryDate}</Text>
            <Text
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} of ${totalPages}`
              }
            />
          </View>
        </View>
        <View
          fixed
          style={{
            display: "flex",
            flexDirection: "column",
            // margin: "10px",
            // marginLeft: "auto",
            width: "170px",
            fontSize: "12",
          }}
        >
          <Text
            render={({ pageNumber, totalPages }) => {
              if (pageNumber === 1) return;

              return `Page ${pageNumber} of ${totalPages}`;
            }}
          />
        </View>

        <View style={styles.header}>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "200px",
              padding: "0px 10px 10px 10px",
              border: "1px solid rgb(0,0,0)",
              margin: "10px",
            }}
          >
            <Text
              style={{
                fontSize: "14",
                marginTop: "-9",
                marginBottom: "4px",
                width: "40px",
                backgroundColor: "white",
              }}
            >
              Bill To
            </Text>
            <View style={{}}>
              <Text>{invoice?.billingAddress?.addressLine || ""}</Text>
              <Text>{invoice?.billingAddress?.addressLine2 || ""}</Text>
              <Text>{`${invoice?.billingAddress?.city || ""} ${
                invoice?.billingAddress?.state || ""
              } ${invoice?.billingAddress?.zip || ""}`}</Text>
              <Text>{invoice?.customerPhoneNumber || ""}</Text>
            </View>
          </View>

          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "200px",
              padding: "0px 10px 10px 10px",
              border: "1px solid rgb(0,0,0)",
              margin: "10px",
              marginLeft: "auto",
            }}
          >
            <Text
              style={{
                fontSize: "14",
                marginTop: "-9",
                marginBottom: "4px",
                width: "50px",
                backgroundColor: "white",
              }}
            >
              Ship To
            </Text>
            <Text>{invoice?.shippingAddress?.addressLine || ""}</Text>
            <Text>{invoice?.shippingAddress?.addressLine2 || ""}</Text>
            <Text>{`${invoice?.shippingAddress?.city || ""} ${
              invoice?.shippingAddress?.state || ""
            } ${invoice?.shippingAddress?.zip || ""}`}</Text>
            <Text>{invoice?.customerPhoneNumber || ""}</Text>
          </View>
        </View>

        <View
          style={{
            // border: "1px 1px solid #000000b5",
            marginTop: "10px",
          }}
        >
          <View
            style={{
              border: "1px solid #000000",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}
            fixed
          >
            <Text style={{ fontSize: "10px", width: "150px" }}>
              product Name
            </Text>
            <Text style={{ fontSize: "10px", width: "200px" }}>
              product Description
            </Text>
            <Text
              style={{
                fontSize: "10px",
                width: "60px",
                textAlign: "center",
              }}
            >
              Quantity
            </Text>
            <Text
              style={{
                fontSize: "10px",
                width: "60px",
                textAlign: "right",
              }}
            >
              price per unit
            </Text>

            <Text
              style={{
                fontSize: "10px",
                width: "60px",
                textAlign: "right",
              }}
            >
              price
            </Text>
          </View>

          {products
            ?.filter((item) => !item.combinedId || item.combinedId < 1)
            // ?.filter((item) => item.packedQuantity > 0)
            ?.sort((a, b) => a.productName.localeCompare(b.productName))
            ?.map((item, i) => {
              return (
                <View
                  style={{
                    // ...(products.length !== i + 1 && {
                    border: "1px solid #000000",
                    // }),
                    // margin: "none",
                    padding: "3px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                  wrap={false}
                  fixed={false}
                >
                  <Text style={{ fontSize: "10px", width: "150px" }}>
                    {item.productName}
                  </Text>

                  <Text style={{ fontSize: "10px", width: "200px" }}>
                    {item.productDescription}
                  </Text>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {item.priceByPound
                      ? item.packedWeight + " lbs"
                      : item.quantity + " pcs"}
                  </Text>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {"$" + item.price.toFixed(2)}
                  </Text>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {item.priceByPound
                      ? "$" + (item.price * item.packedWeight)?.toFixed(2)
                      : "$" + (item.price * item.quantity)?.toFixed(2)}
                  </Text>
                </View>
              );
            })}

          {groupedProducts &&
            Object.keys(groupedProducts).map((item) => {
              console.log(item);
              return (
                <View
                  style={{
                    // ...(products.length !== i + 1 && {
                    border: "1px solid #000000",
                    // }),
                    // margin: "none",
                    // padding: "3px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  wrap={false}
                  fixed={false}
                >
                  <View
                    style={{
                      // ...(products.length !== i + 1 && {
                      // border: "1px solid #000000",
                      // }),
                      // margin: "none",
                      padding: "3px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    wrap={false}
                    fixed={false}
                  >
                    {groupedProducts[item]
                      ?.sort((a, b) =>
                        a.productName.localeCompare(b.productName)
                      )
                      .map((row) => (
                        <>
                          <View
                            style={{
                              padding: "3px",
                              display: "flex",
                              flexDirection: "row",
                            }}
                            wrap={false}
                            fixed={false}
                          >
                            <Text style={{ fontSize: "10px", width: "150px" }}>
                              {row.productName}
                            </Text>

                            <Text style={{ fontSize: "10px", width: "200px" }}>
                              {row.productDescription}
                            </Text>
                          </View>
                        </>
                      ))}
                  </View>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {groupedProducts[item][0].priceByPound
                      ? groupedProducts[item][0].packedWeight + " lbs"
                      : groupedProducts[item][0].quantity + " pcs"}
                  </Text>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {"$" + groupedProducts[item][0].price.toFixed(2)}
                  </Text>

                  <Text
                    style={{
                      fontSize: "10px",
                      width: "60px",
                      textAlign: "right",
                    }}
                  >
                    {groupedProducts[item][0].priceByPound
                      ? "$" +
                        (
                          groupedProducts[item][0].price *
                          groupedProducts[item][0].packedWeight
                        )?.toFixed(2)
                      : "$" +
                        (
                          groupedProducts[item][0].price *
                          groupedProducts[item][0].quantity
                        )?.toFixed(2)}
                  </Text>
                </View>
              );
            })}
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
            }}
          >
            <Text
              style={{
                marginLeft: "auto",
                fontSize: "14px",
                fontWeight: "bold",
                width: "200px",
                textAlign: "right",
              }}
            >
              {"Total: $" +
                uniqueBillibleProducts()
                  .reduce(
                    (acc, curr) =>
                      acc +
                      (curr.priceByPound
                        ? curr.packedWeight * curr.price
                        : curr.quantity * curr.price),
                    0
                  )
                  ?.toFixed(2)}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
            }}
          >
            <View
              style={{
                border: "1px solid #000000",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                height: "100px",
                width: "290px",
              }}
              fixed
              wrap={false}
            >
              <Text style={{ fontSize: "12px", width: "150px" }}>
                Invoice Notes:
              </Text>
              <Text style={{ fontSize: "12px" }}>{invoice?.invoiceNotes}</Text>
            </View>

            <View
              style={{
                border: "1px solid #000000",
                padding: "10px",
                display: "flex",
                flexDirection: "row",
                height: "100px",
                width: "250px",
                marginLeft: "auto",
              }}
              wrap={false}
              fixed
            >
              <Text style={{ fontSize: "12px", width: "150px" }}>
                Signiture:
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
